module.exports = __webpack_public_path__ + "static/media/vacations.c81b91f7.svg";